export default {
  ETH: {
    address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    img: require('@/assets/images/coin/eth.png'),
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH'
  },
  FX: {
    address: '0xc5229C5199d8A306c3f7b4CA43122F684F23f6E6',
    img: require('@/assets/images/coin/fx.png'),
    decimals: 18,
    name: 'f(x) Coin',
    symbol: 'FX'
  },
  NPXS: {
    address: '0x64C69807efaD634cC3b2f46E3140be43c1Ed8aE0',
    img: require('@/assets/images/coin/npxs.png'),
    decimals: 18,
    name: 'Pundi X',
    symbol: 'NPXS'
  },
  XS: {
    address: '0xD4075D8694B90Aa96795c5b24b49aaC1848f8AB2',
    img: require('@/assets/images/coin/npxs.png'),
    decimals: 18,
    name: 'XS',
    symbol: 'XS'
  }
}
